export class Type {
    REL_ATTR: string;

    constructor() {}
}
